import React, { useEffect, useState } from "react";
import CustomSvg from "../svgs/CustomSvg";
import { useUser } from "../../utils/hooks";
import { postRequest } from "../apiRequests/requestApi";
import { useNavigate } from "react-router-dom";
import { Formik, ErrorMessage } from "formik";
import * as yup from 'yup'
import { EMAIL_REGEX } from "../helpers/regex";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import { Spinner } from "react-bootstrap";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { HiOutlineMail } from "react-icons/hi";
import { FaRegFileAlt } from "react-icons/fa";
import { BsShieldLock } from "react-icons/bs";

export default function Help() {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState();
  const [message, setMessage] = useState();
  const [apiReqs, setApiReqs] = useState({ isLoading: false, data: null, errorMsg: null })

  const validationSchema = yup.object().shape({
    email: yup.string().matches(EMAIL_REGEX, "Must be a valid email address").required("Email required"),
    fullName: yup.string().max(50, "Cannot be more than 50 characters").required("Full name required"),
    message: yup.string().max(500, "Cannot be more than 500 characters").required("Message required")
  })

  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);

  const goToProfile = () => navigateTo("/user-profile");
  const { user } = useUser();

  useEffect(() => {
    if (user) {
      setEmail(user.email);
    }
  }, [user]);

  useEffect(() => {
    if(apiReqs.data && apiReqs.isLoading){
      const { data } = apiReqs
      submit({ requestBody: data })
    }
  }, [apiReqs])

  const submit = async ({ requestBody }) => {
    try {

      const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9'

      const response = await postRequest({
        url: "/contact",
        data: requestBody,
        token
      });
      alert("Message Successfully delivered");
      setApiReqs({ isLoading: false, data: null, errorMsg: null })
      goToProfile();

    } catch (error) {
      console.error(error);
      setApiReqs({ isLoading: false, data: null, errorMsg: "Error sending message" })
    }
  };

  const options = [
    {
      label: "FAQ",
      icon: <IoMdHelpCircleOutline size={20} color="#6499FF" />, 
      path: "/user-profile/faq"
    },
    {
      label: "Contact Us",
      icon: <HiOutlineMail size={20} color="#6499FF" />, 
      path: "/user-profile/contact"
    },
    {
      label: "Terms & Condition",
      icon: <FaRegFileAlt size={20} color="#6499FF" />, 
      path: "/user-profile/terms"
    },
    {
      label: "Privacy Policy",
      icon: <BsShieldLock size={20} color="#6499FF" />, 
      path: "/user-profile/privacy"
    },
  ];

  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
      <h2 className="text-white text-2xl font-bold mb-8">Help</h2>
      <div className="w-full max-w-md bg-[#1E1B2E] rounded-2xl p-6 shadow-lg">
        <ul className="space-y-2">
          {options.map((opt, idx) => (
            <li key={opt.label}>
              <button
                className="w-full flex items-center gap-4 p-3 rounded-lg hover:bg-[#23203A] transition text-left"
                onClick={() => navigate(opt.path)}
              >
                <span>{opt.icon}</span>
                <span className="text-white text-base font-medium">{opt.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
